import type { PaginatedOrders, PaginatedUsers, UserWithStats } from '@shop-monorepo/types';
import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../services/api';

const USER_QUERY_KEY = 'users';

interface UsersQueryParams {
  page?: number;
  limit?: number;
  filters?: { role?: string; hasPassword?: boolean; marketingOptIn?: boolean };
  sorter?: { field?: string; direction?: 'asc' | 'desc' };
}

export const useUsers = (params: UsersQueryParams) => {
  return useQuery<PaginatedUsers, Error>({
    queryKey: [USER_QUERY_KEY, params],
    queryFn: () =>
      apiClient.users.all(params.page ?? 1, params.limit ?? 10, params.filters, params.sorter),
    placeholderData: (previousData) => previousData,
  });
};

export const useUser = (id: number) => {
  return useQuery<UserWithStats, Error>({
    queryKey: [USER_QUERY_KEY, id],
    queryFn: () => apiClient.users.getById(id),
    enabled: !!id,
  });
};

export const useUserOrders = (userId: number, params: { page?: number; limit?: number }) => {
  return useQuery<PaginatedOrders, Error>({
    queryKey: [USER_QUERY_KEY, userId, 'orders', params],
    queryFn: () => apiClient.users.getOrders(userId, params.page ?? 1, params.limit ?? 10),
    placeholderData: (previousData) => previousData,
    enabled: !!userId,
  });
};
